module.exports = __webpack_public_path__ + "img/2.012a651e.png";